import { USER_ACTIVE_WINDOW_MS } from '~constants/session';

// Input that counts as "the user is here". Deliberately excludes pointermove and scroll events that fire
// without a person (inertia, timers), so a tab left open is not mistaken for a busy user.
const INPUT_EVENTS = ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const;

// Page load counts as input, so the bootstrap request on opening the app is a foreground request.
let lastInputAt = Date.now();
let lastForegroundRequestAt = Date.now();
let installed = false;

const recordInput = () => {
  lastInputAt = Date.now();
};

/** Installs passive input listeners once per page. Safe to call repeatedly. */
export const installActivityTracking = () => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  INPUT_EVENTS.forEach((type) => window.addEventListener(type, recordInput, { passive: true, capture: true }));
};

export const getLastInputAt = () => lastInputAt;

export const isUserActive = (now: number = Date.now()) => now - lastInputAt <= USER_ACTIVE_WINDOW_MS;

export const markForegroundRequest = (at: number = Date.now()) => {
  lastForegroundRequestAt = at;
};

export const getLastForegroundRequestAt = () => lastForegroundRequestAt;

/** Another tab made a foreground request, so this tab's heartbeat need not repeat it. */
export const noteForegroundRequestFromPeer = (at: number) => {
  if (at > lastForegroundRequestAt) lastForegroundRequestAt = at;
};
